import { render, staticRenderFns } from "./AnonymousResult.vue?vue&type=template&id=5925e836&scoped=true"
import script from "./AnonymousResult.vue?vue&type=script&lang=js"
export * from "./AnonymousResult.vue?vue&type=script&lang=js"
import style0 from "./AnonymousResult.vue?vue&type=style&index=0&id=5925e836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5925e836",
  null
  
)

export default component.exports